import type { IntlShape } from 'react-intl';

import type { ICertificateItemTemplate } from '@share/common-types';
import { ItemTypeEnum } from '@share/common-types';

const RETAIL_DESCRIPTION_TYPE_ORDER: ItemTypeEnum[] = [
  ItemTypeEnum.Hotel,
  ItemTypeEnum.Cruise,
  ItemTypeEnum.Condo,
];

function itemTypeMessageId(type: ItemTypeEnum): string {
  switch (type) {
    case ItemTypeEnum.Hotel:
      return 'certificates.itemType.hotel';
    case ItemTypeEnum.Cruise:
      return 'certificates.itemType.cruise';
    case ItemTypeEnum.Condo:
      return 'certificates.itemType.condo';
    default:
      return 'certificates.itemType.hotel';
  }
}

export const getAverageRetailDescription = (
  intl: IntlShape,
  itemTemplates: ICertificateItemTemplate[],
): string | null => {
  const presentTypes = new Set(itemTemplates.map((item) => item.type));
  const orderedTypes = RETAIL_DESCRIPTION_TYPE_ORDER.filter((type) => presentTypes.has(type));

  if (orderedTypes.length === 0) {
    return null;
  }

  const labels = orderedTypes.map((type) => intl.formatMessage({ id: itemTypeMessageId(type) }));

  if (labels.length === 1) {
    return intl.formatMessage(
      { id: 'certificates.detail.retailDescription.single' },
      { types: labels[0] },
    );
  }
  if (labels.length === 2) {
    return intl.formatMessage(
      { id: 'certificates.detail.retailDescription.pair' },
      { first: labels[0], second: labels[1] },
    );
  }
  return intl.formatMessage(
    { id: 'certificates.detail.retailDescription.triple' },
    { first: labels[0], second: labels[1], third: labels[2] },
  );
};
